import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SideMenu from "@store/Components/Common/SideMenu";
import { PAGE_TYPES } from "@store/constants";
import React, { FC } from "react";
import { css } from "styled-components";

export interface MyAccountSideMenuStyles {
    wrapper?: InjectableCss;
}

export const myAccountSideMenuStyles: MyAccountSideMenuStyles = {
    wrapper: {
        css: css`
            width: 100%;
            box-shadow: ${props => props.theme.shadows?.light60};
        `,
    },
};

const styles = myAccountSideMenuStyles;

const MyAccountSideMenu: FC<WidgetProps> = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <SideMenu pageType={PAGE_TYPES.myAccount} showRootPage showSignOut />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountSideMenu,
    definition: {
        group: "Basic",
        icon: "link-simple",
    },
};

export default widgetModule;
